/**
 * src/components/ui/EmptyState.jsx — richer empty-state than
 * components/ui.jsx's plain `Empty`.
 *
 * `Empty` stays as-is for its existing callers (simple "nothing here yet"
 * text, no action) — this is the new canonical version for anywhere Phase
 * 4-6 wants REDESIGN.md's copy rule applied properly: "empty states name
 * the next action," i.e. an empty client list says "Add your first client"
 * with a real button, not just "No clients."
 */

/**
 * @param {{ title: string, description?: string, action?: React.ReactNode }} props
 * @returns {JSX.Element}
 */
export function EmptyState({ title, description, action }) {
  return (
    <div className="ui-empty-state">
      <p className="ui-empty-state-title">{title}</p>
      {description ? <p className="muted small">{description}</p> : null}
      {action ? <div className="ui-empty-state-action">{action}</div> : null}
    </div>
  );
}
